import { StatusBadge } from 'components/common/StatusBadge'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { FaNetworkWired } from 'react-icons/fa'
import { FiCpu } from 'react-icons/fi'
import { RiRouterLine } from 'react-icons/ri'
import { TbQuestionMark } from 'react-icons/tb'
import { TDeviceType } from 'shared/types'

export const DeviceTypeBadge = ({ type }: { type: TDeviceType }) => {
  const { t } = useTranslation()
  const Icon = useMemo(() => {
    switch (type) {
      case 'LoraDevice':
        return FiCpu
      case 'LoraGateway':
        return RiRouterLine
      case 'SNMP':
        return FaNetworkWired
      default:
        return TbQuestionMark
    }
  }, [type])

  return (
    <StatusBadge color="gray" variant="light" icon={<Icon />}>
      {t(`typeCode.${type}`)}
    </StatusBadge>
  )
}
